import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function displayReports(orderBy, category) {
  const api = `reports/reportType?reportType=${orderBy}&reportCategory=${category}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.reportingInstance().get(api)
}

export async function searchReports(orderBy, category, startDate, endDate) {
  if (!startDate || !endDate) {
    return displayReports(orderBy, category)
  }
  const api = `reports/reportsByDateRange?reportType=${orderBy}&reportCategory=${category}&startDate=${startDate}&endDate=${endDate}`
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  return httpClient.reportingInstance().get(api)
}
